export default __webpack_public_path__ + "static/media/not found.b36ecb93.jpg";